// Shared Leaflet teardown guard.
//
// Leaflet's map.stop() internally calls setZoom(getCenter(), getZoom()),
// which reads _leaflet_pos off the map pane. During React's passive-effect
// unmount the pane DOM node may already be detached (#814/#815), so reading it
// throws "Cannot read properties of undefined (reading '_leaflet_pos')".
// Aborting an in-flight pan/zoom animation on cleanup (before the pane
// detaches) prevents Leaflet's _onZoomTransitionEnd from later reading a
// torn-down pane. Only call stop() when the pane is still attached with a
// known position.
//
// Originally lived inline in pages/ParcelDetail.js (#866). Lifted here (#1060)
// so components/MapView.js can reuse the exact same guard for the search-page
// map instead of duplicating the logic.
export function safeStopMap(map) {
  try {
    if (!map || typeof map.stop !== 'function') return;
    const pane = map.getPane && map.getPane('mapPane');
    if (!pane || pane._leaflet_pos == null) return;
    map.stop();
  } catch (e) { /* pane torn down mid-stop */ }
}
